import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TeamMember } from '../types';

type TeamMembersProps = {
  members?: TeamMember[];
};

const TeamMembers = ({ members }: TeamMembersProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <List>
        {!!members &&
          members.map((member) => (
            <ListItem key={member.id} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
              <ListItemText
                primaryTypographyProps={{ fontSize: '1.25rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
                primary={member.name}
                secondary={
                  <Box>
                    {member.roleId === '7D7759E9-C5F1-40B4-B249-C98B683C7818' && (
                      <Typography>
                        {t('Phone', { defaultValue: 'Phone' })}: {member.phone}
                      </Typography>
                    )}
                    <Typography>
                      {t('Email', { defaultValue: 'Email' })}: {member.email}
                    </Typography>
                    <Typography>
                      {t('Role', { defaultValue: 'Role' })}: {member.role}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
      </List>
    </Box>
  );
};

export default TeamMembers;
